import * as classNames from 'classnames'
import * as React from 'react'
import { RouteComponentProps, withRouter } from 'react-router-dom'
import { isEducator } from 'services/user'

import Forms from '../EvaluationQuestionnaires'
import Abilities from './Abilities'

import ITalentsData from '../../data/abitilies/interfaces/ITalentsData'

import { _route } from '../../routes/config'

export interface INativeProps {
  user: any
  talentsChartData: ITalentsData[]
  patientDetail: any
  openPlusOnlyPopup: () => void
  toggleHistoryModal: () => void
  activeDate?: number | string
  openShareModal: () => void
}

export interface IProps extends INativeProps, RouteComponentProps {}

export interface IState {
  nestedDefault: boolean
}

class Content extends React.PureComponent<IProps> {
  careProfHashes = ['cognitions', 'talents', 'reports', 'forms']
  parentHashes = ['abilities', 'work_plan']

  setNestedDefault = (value: boolean) => {
    this.setState({ nestedDefault: value })
  }

  getParentTabContent = (value: number) => {
    const {
      talentsChartData,
      openPlusOnlyPopup,
      activeDate,
      toggleHistoryModal,
      openShareModal,
      user
    } = this.props

    switch (value) {
      case 0:
        return (
          <Abilities
            toggleHistoryModal={toggleHistoryModal}
            activeDate={activeDate}
            talentsChartData={talentsChartData}
            openPlusOnlyPopup={openPlusOnlyPopup}
            openShareModal={openShareModal}
            role={user.role}
          />
        )
      default:
        return null
    }
  }

  getEducatorTabContent = (value: number) => {
    const {
      talentsChartData,
      openPlusOnlyPopup,
      activeDate,
      toggleHistoryModal,
      openShareModal,
      user
    } = this.props

    switch (value) {
      case 0:
        return (
          <Abilities
            toggleHistoryModal={toggleHistoryModal}
            activeDate={activeDate}
            talentsChartData={talentsChartData}
            openPlusOnlyPopup={openPlusOnlyPopup}
            openShareModal={openShareModal}
            role={user.role}
          />
        )
      default:
        return null
    }
  }

  getCareProfTabContent = (value: number) => {
    const {
      talentsChartData,
      openPlusOnlyPopup,
      activeDate,
      toggleHistoryModal,
      openShareModal,
      user
    } = this.props

    switch (value) {
      case 0:
        return null
      case 1:
        return (
          <Abilities
            toggleHistoryModal={toggleHistoryModal}
            activeDate={activeDate}
            talentsChartData={talentsChartData}
            openPlusOnlyPopup={openPlusOnlyPopup}
            openShareModal={openShareModal}
            role={user.role}
          />
        )
      case 2:
        return null
      // return <Reports patientDetail={patientDetail} />
      // no care prof now, may be deleted
      case 3:
        return <Forms />
      default:
        return null
    }
  }

  getTabContent = (value: number) => {
    const { user } = this.props

    switch (user.role) {
      case 'parent':
        return this.getParentTabContent(value)
      case 'educator':
        return this.getEducatorTabContent(value)
      case 'careProffesional':
        return this.getCareProfTabContent(value)
      default:
        return null
    }
  }

  render() {
    const { user } = this.props
    const educator = isEducator(user?.role)
    return (
      <div
        className={classNames('patient-details-page-content', {
          'page-content': !educator,
          'educator-page-content': educator
        })}
      >
        {this.getTabContent(0)}
      </div>
    )
  }
}

const WithRouter = withRouter(Content)

export default (props: INativeProps) => <WithRouter {...props} />



// WEBPACK FOOTER //
// ./src/pages/PatientDetails/tabs.tsx